import type { Route } from "next";

const DEFAULT_ROUTE = "/" satisfies Route;
const RETURN_TO_ORIGIN = "https://return-to.invalid";

export function parseRelativeRoute(value: string): Route | undefined {
  if (!value.startsWith("/")) return undefined;
  if (value.includes("\\")) return undefined;
  if (/[\u0000-\u001f\u007f]/.test(value)) return undefined;

  try {
    const destination = new URL(value, RETURN_TO_ORIGIN);
    if (destination.origin !== RETURN_TO_ORIGIN) return undefined;
    if (destination.pathname.startsWith("//")) return undefined;

    return `${destination.pathname}${destination.search}${destination.hash}`;
  } catch {
    return undefined;
  }
}

export function sanitizeReturnTo(
  value: string | null | undefined,
  fallback: Route = DEFAULT_ROUTE,
): Route {
  if (!value) return fallback;
  return parseRelativeRoute(value) ?? fallback;
}

const AUTH_ROUTE_PREFIXES = ["/setup", "/sign-in", "/sign-up", "/callback", "/claim-account"];

export function sanitizeSetupReturnTo(
  value: string | null | undefined,
  fallback: Route = "/dashboard",
): Route {
  const route = sanitizeReturnTo(value, fallback);
  const pathname = new URL(route, RETURN_TO_ORIGIN).pathname;
  const isAuthRoute = AUTH_ROUTE_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
  return isAuthRoute ? fallback : route;
}
